import React from 'react';
import { TwitterTweetEmbed } from 'react-twitter-embed';
import TweetPlaceholder from '../tweet-placeholder';
import { StyledTweetWrapper } from './styled';

interface TweetCardProps {
  tweetId: string;
  opacity?: boolean;
}
const TweetCard: React.FC<TweetCardProps> = props => {
  const { tweetId, opacity } = props;
  return (
    <StyledTweetWrapper className="tweet-wrapper">
      {opacity && <div className="opacity-wrapper" />}
      <TwitterTweetEmbed
        tweetId={tweetId}
        placeholder={<TweetPlaceholder />}
        options={{ width: '100%', maxWidth: '100%' }}
      />
    </StyledTweetWrapper>
  );
};

export default TweetCard;
